import Cookies from 'js-cookie'
var CryptoJS = require("crypto-js");

const useAuth = () => {
    var secretKey = 'Key-MOTION-ID@2023';

    const cookieExpiration = () => {
        let date = new Date();
        date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000)) // 1day
        // date.setTime(date.getTime() + (2 * 60 * 60 * 1000)) // 2Hour
        return date;
    }

    const setLogedin = (data) => {
        var encryptData = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
        Cookies.set('S_UID', encryptData, { path: '/', expires: cookieExpiration(), sameSite: 'lax', httpOnly: false })

        return true;
    }

    const setLogout = () => {
        Cookies.remove('S_UID', { path: '/', expires: cookieExpiration(), sameSite: 'lax', httpOnly: false });

        return true;
    }

    const getSession = () => {
        if (Cookies.get('S_UID')) {
            var bytes = CryptoJS.AES.decrypt(Cookies.get('S_UID'), secretKey);
            var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

            return decryptedData;
        } else {
            return undefined
        }
    }

    return {
        setLogedin,
        setLogout,
        getSession
    }

}

export default useAuth;